import { jwtDecode, JwtPayload } from 'jwt-decode';

export type AuthStatus = 'unknown' | 'authenticated' | 'guest';

export type BoardingAuthSectionView = 'session-loading' | 'login' | 'animals';

export function isTokenValid(token: string | null | undefined): boolean {
  if (!token) return false;
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) return true;
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function getInitialAuthStatus(token: string | null | undefined): AuthStatus {
  return isTokenValid(token) ? 'unknown' : 'guest';
}

export function getBoardingAuthSectionView(authStatus: AuthStatus): BoardingAuthSectionView {
  if (authStatus === 'unknown') return 'session-loading';
  if (authStatus === 'guest') return 'login';
  return 'animals';
}

export function shouldPromptBoardingLogin(authStatus: AuthStatus): boolean {
  return authStatus === 'guest';
}

/** Chemin de retour après login : state React Router > session pension > localStorage OAuth. */
export function resolvePostLoginRedirectPath(
  locationFrom: string | undefined,
  boardingReturnPath: string | null,
  redirectAfterAuth: string | null
): string {
  if (locationFrom) return locationFrom;
  if (boardingReturnPath) return boardingReturnPath;
  if (redirectAfterAuth) return redirectAfterAuth;
  return '/';
}
